import { isCountry } from "../country/isCountry"
import { isLanguage } from "../language/isLanguage"
import type { Locale } from "./Locale"

export function isLocale(locale?: unknown): locale is Locale {
	if (typeof locale !== "string") {
		return false
	}

	const [language, countryCode] = locale.split("-")
	return isLanguage(language) && (countryCode === undefined || isCountry(countryCode))
}
